<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.create.title`
        )
      }}
    </h1>
    <p>
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.create.paragraph1`
        )
      }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic1Name" />
    <br />
    <p>
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.create.paragraph2`
        )
      }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic2Name" />
    <br />
    <p>
      {{
        $t(
          `documentation.texts.${
            isEmpresaUser ? 'companiesGD' : 'companies'
          }.create.paragraph3`
        )
      }}
    </p>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['isEmpresaUser']),
    pic1Name() {
      return require('@/assets/documentation/companies/' +
        this.$t(
          `documentation.texts.${
            this.isEmpresaUser ? 'companiesGD' : 'companies'
          }.create.pic1`
        ) +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/companies/' +
        this.$t(
          `documentation.texts.${
            this.isEmpresaUser ? 'companiesGD' : 'companies'
          }.create.pic2`
        ) +
        '.png')
    },
  },
  methods: {
    goDoc(section, subsection = '') {
      if (subsection === '')
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section },
        })
      else
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section, subsection },
        })
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
